import AppFav from '../app-fav'

export default
{
    components:
    {
        AppFav
    },

    props:
    {
        content: { type: Object, default: null },
        isActive: { type: Boolean, default: false }
    },

    watch:
    {
        isActive: 'onActiveChange'
    },

    data()
    {
        return {
            activeIndex: -1,
            isItemOver: false
        }
    },

    created()
    {
        this.eventHub.$on('resize', this.onResize)
    },

    mounted()
    {
        this.$box = this.$el.querySelector('.js-box')

        this.onResize()
    },

    destroyed()
    {
        this.eventHub.$off('resize', this.onResize)
    },

    methods:
    {
        onActiveChange()
        {
            if(this.isActive)
            {
                this.onResize()
            }
        },

        onResize()
        {
            this._boxHeight = this.$box.offsetHeight
        },

        onItemOver(event, index)
        {
            this.isItemOver = true
            this.$el.classList.remove('is-test')

            if(Math.abs(index - this.activeIndex) >= 2)
            {
                this.$box.style.transitionDuration = '0s'
                this.$el.classList.add('is-test')

                this.$nextTick(() =>
                {
                    this.$box.style.transitionDuration = '1s'
                })
            }


            if(index < this.activeIndex)
            {
                this.$el.classList.add('is-prev')
                this.$el.classList.remove('is-next')
            }
            else
            {
                this.$el.classList.add('is-next')
                this.$el.classList.remove('is-prev')
            }

            this.activeIndex = index

            const y = event.currentTarget.offsetTop - this._boxHeight * .5

            this.$box.style.transform = 'translateY(' + y + 'px) translateZ(0)'
        },

        onItemLeave()
        {
            this.isItemOver = false
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/app-encyclopedia-list/script.js